import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    role: null,
    email: null,
    token: null,
    id: null,
    first_name: null,
    last_name: null,
    permissions: null,
    location_id: null,
    organization_id: null,
    tutor_locations: null,
    tutor_programs: null,
    assessment_session_id: null,
}

// Token here is access token
const role_slice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload
        },
        setRole: (state, action) => {
            state.role = action.payload.role
            state.email = action.payload.email
            state.token = action.payload.token
            state.id = action.payload.id
            state.organization_id = action.payload.organization_id
            state.permissions = action.payload.permissions
            state.tutor_locations = action.payload.tutor_locations
            state.tutor_programs = action.payload.tutor_programs
            state.first_name = action.payload.first_name
            state.last_name = action.payload.last_name
        },
        removeRole: (state) => {
            state.role = null
            state.email = null
            state.token = null
        },
        setLocation: (state, action) => {
            state.location_id = action.payload
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload
        },
        setAssessmentSessionId: (state, action) => {
            state.assessment_session_id = action.payload
        },
        removeAssessmentSessionId: (state) => {
            state.assessment_session_id = null
        },
    }
})

export const { setToken, setRole, removeRole, setLocation, setPermissions, setAssessmentSessionId, removeAssessmentSessionId} = role_slice.actions;
export default role_slice.reducer;